<template>
  <div class="list row">
    <div class="col-md-8 mr-4">
      <div class="input-group mb-3">
        <input type="text" v-validate="'required|min:1|max:75'" class="form-control mr-2" placeholder="Search by last name" v-model="searchLastName"/>
        <div class="input-group-append">
          <button class="btn btn-outline-secondary" type="button" @click="page = 1; retrieveUsers();"><font-awesome-icon icon="search" /> Search</button>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <button class="btn btn-primary" @click="newUser"><font-awesome-icon icon="plus" /> Add User</button>
    </div>
    <div class="col-md-12 hgap"></div>
    <div class="col-md-6">
      <h4><font-awesome-icon icon="list-alt" /> Users List</h4>
      <ul class="list-group">
        <li class="list-group-item" :class="{ active: index == currentIndex }" v-for="(user, index) in users" :key="index"  @click="setActiveUser(user, index)">
           {{ user.username }} <span style="color: red;">|</span> {{ user.firstName }} <span style="color: red;">|</span> {{ user.lastName }}
        </li>
      </ul>
      <div class="col-md-12 hgap"></div>
      <div v-if="loading" class="justify-content-center">
        <font-awesome-icon icon="spinner" /> <span>Loading...please wait</span>
      </div>
      <table class="table table-borderless">
        <tr>
          <td>
            <div class="d-flex justify-content-center">
              Items per Page:
              <select v-model="pageSize" @change="handlePageSizeChange($event)">
                <option v-for="size in pageSizes" :key="size" :value="size">
                  {{ size }}
                </option>
              </select>
            </div>
          </td>
          <td>
            <div class="d-flex justify-content-end">
              <b-pagination v-model="page" :total-rows="count" :per-page="pageSize" prev-text="Prev" next-text="Next" @change="handlePageChange"></b-pagination>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <div class="col-md-6">
      <div v-if="currentUser">
        <h4><font-awesome-icon icon="info-circle" /> User Details</h4>
        <table class="table">
        <tr>
          <td><strong>Staff No.:</strong></td><td> {{ currentUser.staffNo }}</td>
        </tr>
        <tr>
          <td><strong>First Name:</strong></td><td> {{ currentUser.firstName }}</td>
        </tr>
        <tr>
          <td><strong>Last Name:</strong></td> <td>{{ currentUser.lastName }}</td>
        </tr>
        <tr>
          <td><strong>Username:</strong></td><td> {{ currentUser.username }}</td>
        </tr>
        <tr>
          <td><strong>Email:</strong></td><td> {{ currentUser.email }}</td>
        </tr>
        <tr>
          <td><strong>Active:</strong></td> <td>{{ currentUser.active ? "Active" : "Inactive" }}</td>
        </tr>
        <tr>
          <td><strong>Role:</strong></td>
          <td><ul>
            <li v-for="(role,index) in currentUser.roles" :key="index">{{ role.name }}</li>
          </ul></td>
        </tr>
        </table>

        <!-- <a class="m-3 btn btn-sm btn-warning" :href="'/users/' + currentUser.id"><font-awesome-icon icon="edit" /> Edit </a>-->
        <router-link :to="{ path: '/users/' + currentUser.id }" class="m-3 btn btn-sm btn-warning"><font-awesome-icon icon="edit" /> Edit </router-link>
      </div>
      <div v-else>
        <br />
        <p>Please click on a User...{{ page }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import UserService from "../services/user.service";

export default {
  name: "users-list",
  data() {
    return {
      users: [],
      currentUser: null,
      currentIndex: -1,
      searchLastName: "",

      page: 1,
      count: 0,
      pageSize: 5,
      pageSizes: [5, 10, 15, 20, 25],
      loading: false
    };
  },
  methods: {
    /*getRequestParams(searchLastName, page, pageSize) {
      let params = {};

      if (searchLastName) {
        params["lastName"] = searchLastName;
      }

      if (page) {
        params["page"] = page - 1;
      }

      if (pageSize) {
        params["size"] = pageSize;
      }

      return params;
    },*/
    
    /*retrieveUsers() {
      UserService.getAll()
        .then(response => {
          this.users = response.data;
          //console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },*/

    retrieveUsers() {
      this.loading = true;
      /*const params = this.getRequestParams(
        this.searchLastName,
        this.page,
        this.pageSize
      );*/
      if (this.page) {
        this.page = this.page - 1;
      }
      UserService.getAllPageable(this.searchLastName, this.page, this.pageSize)
        .then(response => {
          const { users, totalItems } = response.data;
          this.users = users;
          this.count = totalItems;
          this.loading = false;
          //console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },

    handlePageChange(value) {
      this.page = value;
      this.retrieveUsers();
    },

    handlePageSizeChange(event) {
      this.pageSize = event.target.value;
      this.page = 1;
      this.retrieveUsers();
    },

    refreshList() {
      this.retrieveUsers();
      this.currentUser = null;
      this.currentIndex = -1;
    },

    setActiveUser(user, index) {
      this.currentUser = user;
      this.currentIndex = index;
    },

    removeAllUsers() {
      UserService.deleteAll()
        .then(response => {
          console.log(response.data);
          this.refreshList();
        })
        .catch(e => {
          console.log(e);
        });
    },
    
    /*searchByLastName() {
      UserService.getByLastName(this.lastName)
        .then(response => {
          this.users = response.data;
          //console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },*/

    newUser() {
      this.$router.push('/adduser');
    }
  },
  mounted() {
    this.retrieveUsers();
  }
};
</script>

<style>
.list {
  text-align: left;
  max-width: 100%;
  margin: auto;
  margin-top: 3.2em;
}
.paginate{
  margin-top: 1.7em;
}
.hgap{
  clear: both;
  margin-top: 1.1em;
}
</style>
